import { Shadows, createTheme } from "@mui/material";
import { green, orange } from "@mui/material/colors";
import { background, purpleLightActive, purple, purpleLight } from "./colors";
import "./styles.css";
declare module "@mui/material/styles" {
  interface Theme {}
  // allow configuration using `createTheme`
  interface ThemeOptions {}
}

const theme = createTheme({
  palette: {
    primary: {
      light: purpleLightActive,
      main: purple,
    },
    secondary: {
      main: green[500],
    },
    background: {
      default: background,
    },
    common: {},
  },
  typography: {
    fontFamily: `'IBM Plex Sans Devanagari', sans-serif`,
  },
  shadows: [
    "none",
    "rgba(0, 0, 0, 0.08) 0px 1px 4px",
    "0px 2px 2px 0px rgba(0, 0, 0, 0.25)",
    "0px 6px 8px 0px rgba(0, 0, 0, 0.25)",
    "0px 15px 52px 15px rgba(50, 59, 82, 0.15)",
    ...Array(20).fill("none"),
  ] as Shadows,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          paddingRight: 16,
          paddingLeft: 16,
          textTransform: "capitalize",
          fontWeight: 600,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#ABA0AB",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: purple,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: purple,
            borderWidth: 2,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#5B4A5A",
          fontWeight: 500,
          "&.MuiInputLabel-shrink": {
            fontSize: "0.9rem",
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          borderRadius: 10,
          border: "1px solid #ECECEC",
          boxShadow: "0 12px 28px -8px rgba(27, 0, 27, 0.16)",
        },
        listbox: {
          padding: 4,
        },
        option: {
          borderRadius: 6,
          '&[aria-selected="true"]': {
            backgroundColor: `${purpleLight} !important`,
          },
          "&.Mui-focused": {
            backgroundColor: "#F7EFF7",
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 4,
        },
      },
    },
    MuiCard: {
      defaultProps: {},
      styleOverrides: {
        root: {
          // boxShadow: "1px 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)"
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        InputLabelProps: {
          shrink: true,
          classes: {
            asterisk: "red",
          },
        },
      },
    },
  },
});

export default theme;
